import { render } from "./Shifts.vue?vue&type=template&id=0b835c52"
import script from "./Shifts.vue?vue&type=script&lang=js"
export * from "./Shifts.vue?vue&type=script&lang=js"

import "./Shifts.vue?vue&type=style&index=0&id=0b835c52&lang=css"

import exportComponent from "../../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__